const WORKTREE_PORT_MIN = 20_000;
const WORKTREE_PORT_MAX = 45_000;

export function resolveAngularEmulatorPorts(angularPort: number) {
  if (angularPort >= WORKTREE_PORT_MIN && angularPort <= WORKTREE_PORT_MAX - 6) {
    return {
      auth: angularPort + 2,
      firestore: angularPort + 3,
      functions: angularPort + 5,
    };
  }

  return { auth: 9099, firestore: 8080, functions: 5001 };
}
